const React = require("react");
const createReactClass = require("create-react-class");
const PT = require("prop-types");
const _ = require("lodash");

const Tooltip = require("../view/Tooltip");
const AssetsUtil = require("../util/AssetsUtil");
const PageHomeBuilding = require("./PageHomeBuilding");
const {PLAYWRIGHT_TEST_IDS} = require("../../../shared/PlaywrightTestIds");

const styles = require("./styles/PageHome.css");

module.exports = createReactClass({
	displayName: "PageHomeBuilding",

	propTypes: {
		labProps: PT.object.isRequired,
		libraryProps: PT.object.isRequired,
		classProps: PT.object.isRequired,
		theaterProps: PT.object,
		isSimplified: PT.bool,
	},

	getInitialState: function() {
		const time = new Date();
		const seconds = time.getSeconds();

		// Minutes is the next minute ahead of the current time so they clock hands stay in sync
		// with the current time, and the animation is delayed by the number of seconds
		// ahead the hands are
		const minutes = (time.getMinutes() + 1) % 60;
		const minuteHandRotation = (minutes * 360) / 60;
		const hourHandRotation =
			((time.getHours() % 12) / 12) * 360 + minuteHandRotation / 12;
		const minuteHandStyle = {
			transform: "rotate(" + minuteHandRotation + "deg)",
		};
		const hourHandStyle = {
			transform: "rotate(" + hourHandRotation + "deg)",
		};
		const day = (time.getDate() % 25) + 1;
		const secondsDelay = 59 - seconds;

		return {
			minuteHandStyle,
			hourHandStyle,
			day,
			clockAnimationDelay: secondsDelay + "s",
		};
	},

	renderBuildingForSpace: function(space, imageSrc) {
		const propsName = `${space}Props`;
		const props = this.props[propsName];

		const {tooltipText, tooltipSize, tooltipDirection, buttonProps} = props;
		return (
			<Tooltip
				tooltipText={tooltipText}
				size={tooltipSize}
				direction={tooltipDirection}
			>
				<PageHomeBuilding
					imageSrc={imageSrc}
					imageStyle={
						styles[
							space +
								(this.props.isSimplified && space === "library"
									? "Simplified"
									: "")
						]
					}
					buildingName={space}
					buttonProps={buttonProps}
				/>
			</Tooltip>
		);
	},

	renderClassBuilding: function() {
		const {buttonProps, style} = this.props.classProps;
		const {clockAnimationDelay} = this.state;
		const {minuteHandStyle} = this.state;
		const {hourHandStyle} = this.state;
		_.extend(minuteHandStyle, {
			animationDelay: clockAnimationDelay,
		});
		_.extend(hourHandStyle, {
			animationDelay: clockAnimationDelay,
		});

		const clock = (
			<div
				className={styles.clock}
				data-testid={PLAYWRIGHT_TEST_IDS.HOME_CLOCK_FACE}
			>
				<img
					className={styles.face}
					src={AssetsUtil.getHomescreenImage("clock-face")}
				/>
				<div className={styles.clockDot} />
				<div className={styles.minuteOuter}>
					<img
						style={minuteHandStyle}
						className={styles.minute}
						src={AssetsUtil.getHomescreenImage("clock-minute-hand")}
					/>
				</div>
				<div className={styles.hourOuter}>
					<img
						style={hourHandStyle}
						className={styles.hour}
						src={AssetsUtil.getHomescreenImage("clock-hour-hand")}
					/>
				</div>
			</div>
		);
		return (
			<PageHomeBuilding
				imageSrc={AssetsUtil.getHomescreenImage("main-building")}
				imageStyle={style}
				buttonProps={buttonProps}
			>
				{clock}
			</PageHomeBuilding>
		);
	},

	render: function() {
		const labBuilding = this.renderBuildingForSpace(
			"lab",
			AssetsUtil.getHomescreenImage("lab")
		);
		const theaterBuilding = this.props.theaterProps
			? this.renderBuildingForSpace(
					"theater",
					AssetsUtil.getHomescreenImage("theater")
			  )
			: null;
		const libraryBuilding = this.renderBuildingForSpace(
			"library",
			AssetsUtil.getHomescreenImage("library")
		);
		const classBuilding = this.renderClassBuilding();

		return (
			<React.Fragment>
				{labBuilding}
				{theaterBuilding}
				{libraryBuilding}
				{classBuilding}
				{this.props.children}
			</React.Fragment>
		);
	},
});
